import type { ReplotChartNames } from '../constants';

export const plotTestId = (plotName: ReplotChartNames) => {
  return `plot-${plotName}`;
};
